import api from "./api";

// Public, no login needed: the occupation catalogue and pages.
export class OccupationApiService {
    // Public landing teaser: top jobs and categories, names and counts only.
    static Highlights() {
        return api.get("api/highlights");
    }

    static Locations() {
        return api.get("api/locations");
    }

    static Catalog(query: string, location: string, page: number, category = "") {
        return api.get("api/occupations", { params: { query, location, page, category: category || undefined } });
    }

    static Categories(location = "Global") {
        return api.get("api/categories", { params: { location } });
    }

    static Occupation(id: string | number, location: string) {
        return api.get(`api/occupations/${id}`, { params: { location } });
    }
}
